// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowUp16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-up': IconArrowUp;
    }
}

/**
 * The icon component for the 'arrowUp' icon
 */
export class IconArrowUp extends IconSvg {
    public constructor() {
        super(arrowUp16X16);
    }
}

registerIconSvg('icon-arrow-up', IconArrowUp);
export const iconArrowUpTag = 'nimble-icon-arrow-up';
